/**
 * Returns a warm, time-of-day salutation ("Good morning" / "Good afternoon" /
 * "Good evening") based on the local hour. Used as the lead of the chat
 * entry-point greetings so opening the coach feels like a warm login prompt
 * ("Good evening, Sergio — what would you like to eat?") rather than a neutral
 * one. Boundaries: morning < 12:00, afternoon < 18:00, evening otherwise.
 */
export const getTimeOfDayGreeting = (date = new Date()): string => {
  const hour = date.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
};
